export default __webpack_public_path__ + "static/media/Pink-Blue-Texture.8291856a.jpeg";